import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class Efficiency {
  // 总数量对比数据
  static getAllQuantityComparison(option) {
    let url = `/oa/api/product/efficiency/warehouse/goods?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 班组列表
  static getTeamList(option) {
    let url = `/oa/api/product/efficiency/team/group/order?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 24H各时间阶段混品/同品数量和总数量对比数据
  static getTwentyFourContrast(option) {
    let url = `/oa/api/product/efficiency/team/group/goods?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Efficiency;